// extracted by mini-css-extract-plugin
export var aboveInput = "_n7-0";
export var actionButton = "_n7-5";
export var actionButtonContainer = "_n7-1";
export var actionIcon = "_n7-6";
export var aiInfoContainer = "_n7-2";
export var attachmentWrapper = "_n7-7";
export var bold = "_n7-3";
export var checkIcon = "_n7-8";
export var clickingRecipientBar = "_n7-11";
export var commentThreadSwitch = "_n7-a";
export var draftImage = "_n7-b";
export var draftImageContainer = "_n7-c";
export var draftImages = "_n7-e";
export var editButton = "_n7-g";
export var editor = "_n7-f";
export var editorContainer = "_n7-y";
export var editorErrorTooltipWrapper = "_n7-9";
export var headerDivider = "_n7-h";
export var icon = "_n7-i";
export var info = "_n7-j";
export var internal = "_n7-n";
export var internalDivider = "_n7-k";
export var internalMessage = "_n7-l";
export var messageInputCard = "_n7-m";
export var messageInputForm = "_n7-o";
export var messageInputFormInternal = "_n7-p";
export var options = "_n7-q";
export var publicMessageCustomer = "_n7-s";
export var publicMessageMerchant = "_n7-r";
export var removeImageButton = "_n7-d";
export var replyButtons = "_n7-t";
export var showSignatureButton = "_n7-u";
export var spinner = "_n7-v";
export var verticalButtonDivider = "_n7-4";
export var visibilitySelector = "_n7-w";
export var warning = "_n7-x";
export var wrappingText = "_n7-z";
export var writingInternalNoteTopBorder = "_n7-10";